// extracted by mini-css-extract-plugin
export var appStatus = "J_cV_";
export var compact = "o66YE";
export var metaos = "B4eGf";
export var noThemeAppLogoBackground = "mdiUF";